import React, { useEffect, useMemo, useState } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';
import api from '../../services/api';

import whatsappIcon from '../../assets/whatsapp.png';

import './styles.css';

function PedidoPix() {
    const location = useLocation();
    const [cliente, setCliente] = useState({});

    const orderData = useMemo(() => {
        const fallback = localStorage.getItem('last_order_data');
        return location.state || (fallback ? JSON.parse(fallback) : {});
    }, [location.state]);

    useEffect(() => {
        const subdominio = window.location.hostname.split('.')[0];

        api.get(`clientes/${subdominio}`).then(response =>{
            setCliente(response.data[0] || {});
        });
    }, []);

    function handleCopyPixButton() {
        navigator.clipboard.writeText(cliente.pix_copia_cola || cliente.chave_pix || '');
    }

    function buildWhatsappUrl() {
        const phoneNumber = String(cliente.whatsapp || '').replace(/\D/g, '');
        const text = window.encodeURIComponent(`Olá ${cliente.nome_empresa}! Meu nome é ${orderData.name || ''} e gostaria de confirmar meu pedido.`);
        return `https://wa.me/${phoneNumber}?text=${text}`;
    }

    function handleWhatsappButton() {
        window.open(buildWhatsappUrl(), '_blank', 'noopener,noreferrer');
    }

    return (
        <div id="order_complete_container">
            <header>
                <Link to="/">
                    Voltar ao menu
                    <FiChevronRight size={16}></FiChevronRight>
                </Link>
            </header>
            <main>
                <h1>Obrigado pelo seu pedido!</h1>
                <p>Realize o pagamento via Pix.</p>

                <div className="line" />

                <div className="field">
                    <h3>Valor do pedido</h3>

                    <span>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(orderData.totalValue || 0)}</span>
                </div>

                <div className="field">
                    <h3>Pix
                        {cliente.tipo_chave_pix && (
                            <> ({cliente.tipo_chave_pix})</>
                        )}
                    </h3>

                    <span>{cliente.chave_pix}</span>
                </div>

                {cliente.pix_copia_cola && (
                    <>
                        <div className="pix_copy_paste">
                            <h3>Resumo para transferência</h3>

                            <p>{cliente.pix_copia_cola}</p>
                        </div>

                        <div className="copy_pix">
                            <button
                                className="copy_pix"
                                onClick={handleCopyPixButton}
                            >
                                Copiar chave Pix
                            </button>
                        </div>
                    </>
                )}

                <h2>Você já realizou o pagamento?</h2>
                <p>Envie-nos o comprovante</p>

                <button className="whatsapp_button" onClick={handleWhatsappButton}>
                    Enviar comprovante
                    <img src={whatsappIcon} alt="WhatsApp" />
                </button>
            </main>
        </div>
    );
}

export default PedidoPix;
